export const projects = [
    {
        id: 1,
        name: 'Bookstore Management System',
        img: 'bookstore_app.webp',
        description: 'A bookstore management terminal-based application that helps users search, list and place order.',
        link: 'https://github.com/anhthu106/Bookstore-Management',
        tech: ['Python', 'prettytable'],
    },
    {
        id: 2,
        name: 'Python Quiz App',
        img: 'python_quiz_app.webp',
        description: 'A responsive website that helps students verify their knowledge about Python.',
        link: 'https://github.com/thupham02/demo_asm3_IIT/',
        tech: ['HTML', 'CSS', 'JavaScript'],
    },
    {
        id: 3,
        name: 'Instakilogram',
        img: 'instakilogram.webp',
        description: 'A mobile-friendly social media application that stimulates functionalities and user interface of Instagram.',
        link: 'https://github.com/anhthu106/Instagram-clone',
        tech: ['HTML', 'CSS', 'JavaScript', 'PHP'],
    },
    {
        id: 4,
        name: 'Museum Website',
        img: 'museum_website.webp',
        description: 'A museum website that allows user to view 3D artifacts of Chinese, Japanese and Korean dynasties.',
        link: 'https://github.com/anhthu106/museum-web',
        tech: ['HTML', 'CSS', 'JavaScript', 'Python'],
    },
]
